__turbopack_context__.v({
  "benefitItem": "CartOverview-module__SJnB0G__benefitItem",
  "benefitsSection": "CartOverview-module__SJnB0G__benefitsSection",
  "buttonWrapper": "CartOverview-module__SJnB0G__buttonWrapper",
  "card": "CartOverview-module__SJnB0G__card",
  "content": "CartOverview-module__SJnB0G__content",
  "disclaimer": "CartOverview-module__SJnB0G__disclaimer",
  "divider": "CartOverview-module__SJnB0G__divider",
  "lineItem": "CartOverview-module__SJnB0G__lineItem",
  "lineItemLabel": "CartOverview-module__SJnB0G__lineItemLabel",
  "lineItemPrice": "CartOverview-module__SJnB0G__lineItemPrice",
  "taxInfo": "CartOverview-module__SJnB0G__taxInfo",
  "totalContainer": "CartOverview-module__SJnB0G__totalContainer",
});
